// extracted by mini-css-extract-plugin
module.exports = {"highlight":"TeamsHighlight_highlight___v5gI","rtl":"TeamsHighlight_rtl__sVloi","imgContainer":"TeamsHighlight_imgContainer__9V4IZ","text":"TeamsHighlight_text__X_oje"};